import type { HTMLAttributes, ReactNode } from 'react'

/** Stavebni bloky rozvrzeni pro pocitac (navrh design/sklo, desktop_a.py). */

export function DeskToolbar({
  crumb,
  title,
  sub,
  actions,
}: {
  crumb?: ReactNode
  title: string
  sub?: ReactNode
  actions?: ReactNode
}) {
  return (
    <header className="desk-toolbar">
      <div className="desk-toolbar-text">
        {crumb && <span className="desk-crumb">{crumb}</span>}
        <h1 className="desk-title">{title}</h1>
        {sub && <span className="desk-sub">{sub}</span>}
      </div>
      {actions && <div className="desk-toolbar-actions">{actions}</div>}
    </header>
  )
}

export function Panel({
  title,
  meta,
  action,
  className,
  children,
  ...rest
}: {
  title?: ReactNode
  meta?: ReactNode
  action?: ReactNode
  children: ReactNode
} & Omit<HTMLAttributes<HTMLElement>, 'title' | 'children'>) {
  const head = Boolean(title) || Boolean(meta) || Boolean(action)
  return (
    <section {...rest} className={['glass-panel', className].filter(Boolean).join(' ')}>
      {head && (
        <div className="panel-head">
          {title && <h2 className="panel-title">{title}</h2>}
          <span className="row">
            {meta && <span className="panel-meta">{meta}</span>}
            {action}
          </span>
        </div>
      )}
      {children}
    </section>
  )
}

/** Souhrn vpravo od obsahu; lepi se k horni hrane okna. */
export function Inspector({ label, children }: { label: string; children: ReactNode }) {
  return (
    <aside className="desk-inspector" aria-label={label}>
      {children}
    </aside>
  )
}

export function MoneyLine({ label, value, strong = true }: { label: ReactNode; value: string; strong?: boolean | undefined }) {
  return (
    <div className="money-line">
      <span>{label}</span>
      <span className={strong ? 'money-line-value is-strong' : 'money-line-value muted'}>{value}</span>
    </div>
  )
}
